import React from "react";

const Photo5Shape = ({ image }) => {
  return (
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 200 200" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        <clipPath id="photo5Clip">
          <path d="M100.72 0.5C154.86 0.500005 198.75 44.3897 198.75 98.5303V198.75H95.6846C43.1155 198.75 0.5 156.134 0.5 103.564V100.72C0.5 45.3699 45.3699 0.5 100.72 0.5Z" />
        </clipPath>
      </defs>
      
      <path 
        d="M100.72 0.5C154.86 0.500005 198.75 44.3897 198.75 98.5303V198.75H95.6846C43.1155 198.75 0.5 156.134 0.5 103.564V100.72C0.5 45.3699 45.3699 0.5 100.72 0.5Z" 
        fill="#FF3D00" 
        stroke="black"
        strokeWidth="1"
      />
      
      <image
        href={image}
        x="0"
        y="0"
        width="200"
        height="200"
        clipPath="url(#photo5Clip)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  );
};

export default Photo5Shape;